// Extend the default Number object with a formatMoney() method:
// usage: someVar.formatMoney(decimalPlaces, symbol, thousandsSeparator, decimalSeparator)
// defaults: (2, "R$", ".", ",")
export const float2Money = function (v, places, symbol, thousand, decimal) {
  places = !isNaN(places = Math.abs(places)) ? places : 2
  return _formatMoney(v.toFixed(places).replace('.', ''), places, symbol, thousand, decimal)
}

export const int2Money = function (v, places, symbol, thousand, decimal) {
  return _formatMoney(v, places, symbol, thousand, decimal)
}

export const _formatMoney = function (number, places, symbol, thousand, decimal) {
  places = !isNaN(places = Math.abs(places)) ? places : 2
  symbol = symbol !== undefined ? symbol : 'R$'
  symbol = symbol.trim() + ' '
  thousand = thousand || '.'
  decimal = decimal || ','
  let negative = number < 0 ? '-' : ''
  let i = parseFloat(toFixed(Math.abs(number || 0), places), 10) + ''
  i = i.length > 3 ? i : '000'.substr(i.length) + i
  let d = i.substr(-places)
  i = i.substr(0, i.length - places)
  let j = i.length > 3 ? i.length % 3 : 0
  return symbol +
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    decimal + d
}

export const toFixed = function (v, digits) {
  digits = !isNaN(digits = Math.abs(digits)) ? digits : 2
  let value = v + ''
  let match = value.split('.')
  let decimal = !match[1] ? '0' : match[1].substr(0, digits)
  decimal = decimal.length > digits ? decimal : decimal + (0).toFixed(digits).substr(2 + decimal.length)
  return `${match[0]}.${decimal}`
}

export const centavos2real = function (v) {
  return v / 100
}

export const real2centavos = function (v) {
  const value = toFixed(v, 2)
  return string2int(value + '')
}

export const string2int = function (v) {
  return parseInt(v.replace(/[^0-9]/g, ''))
}
